import { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import { usePrefersReducedMotion } from '../hooks/usePrefersReducedMotion'
import './AddProductSuccess.css'

export default function AddProductSuccess({ payload, onDone }) {
  const reducedMotion = usePrefersReducedMotion()
  const [leaving, setLeaving] = useState(false)
  const onDoneRef = useRef(onDone)
  const playKeyRef = useRef(null)

  onDoneRef.current = onDone

  useEffect(() => {
    if (!payload) {
      playKeyRef.current = null
      setLeaving(false)
      return undefined
    }

    const playKey = payload.id || 'added'
    if (playKeyRef.current === playKey) return undefined
    playKeyRef.current = playKey
    setLeaving(false)

    const fadeAt = reducedMotion ? 720 : 1180
    const doneAt = reducedMotion ? 920 : 1460
    const fadeTimer = window.setTimeout(() => setLeaving(true), fadeAt)
    const doneTimer = window.setTimeout(() => onDoneRef.current?.(), doneAt)
    return () => {
      window.clearTimeout(fadeTimer)
      window.clearTimeout(doneTimer)
    }
  }, [payload, reducedMotion])

  if (!payload) return null

  return createPortal(
    <div
      className={`add-product-success${reducedMotion ? ' is-static' : ''}${leaving ? ' is-leaving' : ''}`}
      role="status"
      aria-live="polite"
    >
      <div className="add-product-success-anchor">
        <div className="add-product-success-mark" aria-hidden="true">
          <svg className="add-product-success-svg" viewBox="0 0 72 72">
            <circle className="add-product-success-ring" cx="36" cy="36" r="22" />
            <circle className="add-product-success-sheen" cx="28" cy="27" r="7" />
            <path className="add-product-success-check" d="M24.5 36.4l7.2 7.1 16-16.2" />
          </svg>
        </div>
        <p className="add-product-success-caption">
          <span className="add-product-success-caption-motion">{payload.notice || 'Produit ajouté !'}</span>
        </p>
      </div>
    </div>,
    document.body,
  )
}
